import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { CandidateStatusChip } from 'modules/analyse/components/CandidateStatusChip';
import { CandidateStatus } from 'generated-graphql/types';

type Props = {
  fullName: string;
  candidateStatus: CandidateStatus | undefined | null;
  email: string | undefined | null;
  phoneNumber: string | undefined | null;
};

export const CandidateHeading: React.FC<Props> = ({
  fullName,
  candidateStatus,
  email,
  phoneNumber
}) => {
  return (
    <>
      <Stack direction="row" spacing="20px" alignItems="center">
        <Typography
          sx={{
            fontSize: '30px',
            lineHeight: '38px',
            fontWeight: 400
          }}
        >
          {fullName}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <CandidateStatusChip status={candidateStatus} />
        {phoneNumber && (
          <>
            <Typography>|</Typography>
            <Typography>
              <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
            </Typography>
          </>
        )}
        {email && (
          <>
            <Typography>|</Typography>
            <Typography>
              <Link href={`mailto:${email}`}>{email}</Link>
            </Typography>
          </>
        )}
      </Stack>
    </>
  );
};
